export const CONTEXT_MAX_CHARACTERS = 5000
